import { useState } from "react";
import { ImageIcon } from "lucide-react";
import { photoSrc } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

const fieldStyle =
  "bg-[#0A0C10] border-white/15 text-slate-100 placeholder:text-slate-600 focus-visible:ring-[#FF3B30] rounded-none h-10";

export const ImageField = ({ label, value, onChange, photos, testid, required = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      {label && (
        <p className="text-[10px] font-mono uppercase tracking-[0.22em] text-slate-500 mb-1.5">{label}</p>
      )}
      <div className="flex gap-2">
        <Input
          data-testid={testid}
          required={required}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://… or pick from library"
          className={fieldStyle}
        />
        <button
          type="button"
          data-testid={`${testid}-browse`}
          onClick={() => setOpen(true)}
          className="shrink-0 flex items-center gap-2 border border-white/20 hover:border-amber-400 hover:text-amber-400 text-slate-300 text-[10px] font-mono uppercase tracking-[0.15em] px-3 transition-colors"
        >
          <ImageIcon size={13} /> Library
        </button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid={`${testid}-picker-modal`} className="bg-[#12151C] border-white/15 text-slate-100 rounded-none sm:max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-heading font-extrabold uppercase tracking-tight text-xl">
              Pick From Photo Library
            </DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-2">
            {photos.map((p) => (
              <button
                key={p.id}
                type="button"
                data-testid={`${testid}-pick-${p.id}`}
                onClick={() => {
                  onChange(photoSrc(p));
                  setOpen(false);
                }}
                className="group relative border border-white/10 hover:border-[#FF3B30] overflow-hidden text-left transition-colors"
              >
                <img src={photoSrc(p)} alt={p.title} className="h-28 w-full object-cover" loading="lazy" />
                <p className="p-2 text-[10px] font-mono uppercase tracking-[0.12em] text-slate-400 group-hover:text-white truncate">
                  {p.title}
                </p>
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
